import React from "react";
import { Link } from "react-router-dom";
import { usePublicLang } from "../../../config/i18n/public";


export default function FooterBlack() {
  const { copy } = usePublicLang();
  const c = copy.footer_black;
  return (
    <footer className="w-full bg-[#181818] text-white">
      {/* Top block with rounded top corners */}
      <div className="mx-auto max-w-[1400px] px-6 py-12 sm:px-10 sm:py-16 flex flex-col md:flex-row md:items-start md:justify-between rounded-t-3xl">
        {/* Left column */}
        <div>
          <div className="flex items-center gap-3">
            <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-white border border-[#DEF1FF] overflow-hidden shadow-sm">
              <img src="/steffi/logo.png" alt="Logo" className="h-12 w-12 object-contain" />
            </div>
            <span className="text-xl font-bold">SteffiCare</span>
          </div>

          <h3 className="mt-5 max-w-md text-base text-gray-200">
            {c.title}
          </h3>

          <Link to="/termin">
            <button
                className="mt-6 inline-flex items-center gap-2 rounded-full bg-[#3b82f6] px-6 py-3 text-base font-semibold text-white shadow-md hover:bg-[#2563eb] transition-colors"
            >
                {c.cta} <ArrowRightIcon />
            </button>
        </Link>
        </div>

        {/* Right column */}
        <div className="mt-10 md:mt-0">
          <h3 className="text-lg font-semibold">{c.contact_title}</h3>
          <ul className="mt-4 space-y-2 text-gray-300 text-sm">
            <li>
              <span className="mr-2 font-medium">{c.phone_label}</span>
              <a
                href={`tel:${copy.contact.phone.replace(/\s+/g, "")}`}
                className="text-blue-400 hover:underline"
              >
                {copy.contact.phone}
              </a>
            </li>
            <li>
              <span className="mr-2 font-medium">{c.email_label}</span>
              <a
                href={`mailto:${copy.contact.email}`}
                className="text-blue-400 hover:underline"
              >
                {copy.contact.email}
              </a>
            </li>
            {c.address_lines.map((line, i) => (
              <li key={i} className={i === 0 ? "pt-2" : ""}>
                {line}
              </li>
            ))}
          </ul>
        </div>
      </div>

    </footer>
  );
}


function ArrowRightIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      className="h-5 w-5"
    >
      <path d="M5 12h14M12 5l7 7-7 7" />
    </svg>
  );
}
